import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import { RootState } from "app/store";
import { CONTACT_PROFILE_LOOKUP } from "app/redux";
import {
  getObjectFromSessionStore,
  getSessionStore,
  setObjectInSessionStore,
} from "app/utils/sessionStore";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import PageHeader from "app/pages/InteractiveProposal/InteractiveProposalHeader";
import InteractiveReviewCenterSidebar from "./InteractiveReviewCenterSidebar";
import { makeRequest } from "app/utils/makeRequest";
import { ProposalTypes } from "app/utils/types";

const InteractiveReviewCenterLayout = () => {
  const lookUpResponse = useSelector((state: RootState) => state?.contactProfileLookup);
  const { isLoading } = lookUpResponse;
  const dispatch = useDispatch();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCommentMode, setIsCommentMode] = useState(false);
  const mainContentRef = useRef<HTMLDivElement>(null);
  const [selectedYear, setSelectedYear] = useState(1);
  const [selectedCreditType] = useState("preCredit");
  const [animationData, setAnimationData] = useState<any>(null);
  const lottieRef = useRef<any>(null);

  const { summaryData: proposalSummary, summaryError, summaryLoading } = useIPContext();
  const getlookUpResponse = getObjectFromSessionStore("lookUpResponse");
  const location = useLocation();
  const pathName = location.pathname.split("/")[2];
  const planId = getSessionStore("planInfo")?.planId;
  const [, setSummaryData] = useState<any | null>(null);
  const [, setLoading] = useState(false);

  const animationURL = () => {
    if (proposalSummary?.proposalType === ProposalTypes.KeyPersonInsurance) {
      return "https://iapp.alexmelik.com/wp-content/uploads/2024/08/Key-Person.json";
    }
    if (proposalSummary?.proposalType === ProposalTypes.BuySell) {
      return "https://iapp.alexmelik.com/wp-content/uploads/2023/09/Buy-Sell.json";
    }
    if (proposalSummary?.proposalType === ProposalTypes.PremiumFinance) {
      return "https://iapp.alexmelik.com/wp-content/uploads/2023/09/Premium-Finance.json";
    }
    return "https://iapp.alexmelik.com/wp-content/uploads/2023/09/Split-Dollar.json";
  };

  useEffect(() => {
    if (!proposalSummary?.proposalType) return;
    fetch(animationURL())
      .then((res) => res.json())
      .then((data) => setAnimationData(data));
  }, [proposalSummary?.proposalType]);

  // Scroll to top on route change
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [pathName]);

  // const formatCreditTypeLabel = (ct: string) =>
  //   ct === "postCredit" ? "Post-Credit" : "Pre-Credit";

  // function mapReviewsToSteps(
  //   reviews: any[],
  //   // eslint-disable-next-line
  //   selectedYear: number,
  //   // eslint-disable-next-line
  //   selectedCreditType: string,
  // ): any[] {
  //   return reviews.map((r) => {
  //     if (r.planYear === selectedYear) {
  //       return {
  //         yearNumber: r.planYear,
  //         calendarYear: r.year,
  //         status: "CURRENT",
  //         label: formatCreditTypeLabel(selectedCreditType),
  //       };
  //     }
  //     if (!r.reviewCompleted && r.confirmedBy === 0) {
  //       return { yearNumber: r.planYear, calendarYear: r.year, status: "LOCKED" };
  //     }
  //     if (r.confirmedBy > 0) {
  //       return {
  //         yearNumber: r.planYear,
  //         calendarYear: r.year,
  //         status: "COMPLETED",
  //         label: `Confirm (${r.confirmedBy})`,
  //       };
  //     }
  //     return {
  //       yearNumber: r.planYear,
  //       calendarYear: r.year,
  //       status: "SKIPPED",
  //       label: `Skip (${r.planYear})`,
  //     };
  //   });
  // }

  // Ensure lookup data is available for header branding
  useEffect(() => {
    if (!getlookUpResponse?.menu) {
      dispatch({
        type: CONTACT_PROFILE_LOOKUP,
        payload: { address: "lookupAfter" },
      });
    }
  }, []);

  useEffect(() => {
    if (lookUpResponse?.data?.menu) {
      setObjectInSessionStore("lookUpResponse", lookUpResponse?.data);
    }
  }, [lookUpResponse]);

  useEffect(() => {
    if (!planId) return;

    setLoading(true);
    makeRequest("interactiveReviewCenterSummary")
      .get(`${planId}?year=${selectedYear}&creditType=${selectedCreditType}`, true)
      .then((res: any) => {
        const data: any = res?.data?.data;
        setSummaryData(data);
        setSelectedYear(data.selectedYear);
      })
      .catch((err: any) => {
        console.error("Failed to fetch review center summary:", err);
      })
      .finally(() => setLoading(false));
  }, [planId, selectedYear, selectedCreditType]);

  // const yearSteps: any[] = summaryData
  //   ? mapReviewsToSteps(summaryData.planReviews, selectedYear, selectedCreditType)
  //   : [];

  const loadingPage = isLoading || summaryLoading;

  const mainContent = () => {
    if (loadingPage) {
      return (
        <div className="flex justify-center items-center h-full">
          <ProgressSpinner />
        </div>
      );
    }
    return <Outlet />;
  };

  console.log(proposalSummary, "fdfdrffgdrg");

  return (
    <div className={`flex h-screen ${isCommentMode ? "comment-mode" : ""}`}>
      <PageHeader
        title={proposalSummary?.employerName}
        subtitle={`${proposalSummary?.primaryContact?.firstName ?? ""} ${
          proposalSummary?.primaryContact?.lastName ?? ""
        }`}
        proposalNo={proposalSummary?.proposalNo}
        proposalType={proposalSummary?.proposalType}
        error={summaryError}
        loadingPage={loadingPage}
        isCollapsed={isCollapsed}
        animationData={animationData}
        setIsHovered={() => {}}
        lottieRef={lottieRef}
        setIsCommentMode={setIsCommentMode}
        isCommentMode={isCommentMode}
        // yearData={yearSteps}
        // creditTypeData={summaryData?.selectedCreditType ?? selectedCreditType}
        // onPhaseClick={(phase) => {
        //   setSelectedCreditType(phase);
        //   setSessionStore("ircSelectedCreditType", phase);
        // }}
      />

      <InteractiveReviewCenterSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div
        ref={mainContentRef}
        className="flex-1 overflow-auto overflow-x-hidden h-[calc(100vh-70px)] mt-auto py-4 pl-6 pr-4 scrollbar-hide"
      >
        {mainContent()}
      </div>
    </div>
  );
};

export default InteractiveReviewCenterLayout;
